import React, {Component} from 'react'
import {graphql, StaticQuery, Link} from 'gatsby'
import styled from "styled-components"
import {media} from "utils/Media"
import ReactPlayer from "react-player"
import Socials from "../Socials";

const IndexHeader = styled.div`
  width: 100%;
  background-color: black;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 2rem;

  @media ${media.md} {
    height: 80px;
    justify-content: space-between;
  }
`

const Logo = styled.div`
  img {
    width: 200px;
    @media ${media.md} {
      width: 100%;
    }
  }
`

const VideoWrap = styled.div`

  width: 100%;
  height: 100%;
  //display: none;

  .embed-responsive-item {
    width: 100% !important;
    height: 100% !important;
  }

  iframe {
    pointer-events: none;
  }

  @media ${media.md} {
    display: block;
  }
`

const Content = styled.div`
  padding: 3rem 0;

  .list {

    .listRow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0.5rem auto;
      padding-bottom: 1rem;
      border-bottom: 1px dotted black;
    }

    .location {
      width: 280px;

      h3 {
        text-transform: none !important;
        text-decoration-color: #DE691B;
        text-decoration-thickness: auto;
        text-decoration-line: underline;
      }
    }

    .when {
      display: none;
      @media ${media.md} {
        display: block;
      }
    }

    .where {
      display: none;
      @media ${media.md} {
        display: block;
      }
    }

    .button {
      .btn {
        width: 100px;
        height: 40px;
        padding: 11px 0px;
        font-size: 1.125rem;
        @media ${media.sm} {
          width: 140px;
          padding: 9px 10px;
          font-size: 1.5rem;
        }
        @media ${media.lg} {
          width: 233px;
          height: 50px;
          padding: 15px 10px;
        }
      }
    }
  }
`

class CleanHeader extends Component {
    constructor(props) {
        super(props)

        this.state = {
            players: [],
            videoOverlays: false,
            isBackgroundVideoPlaying: false,
            locations: [
                {
                    flag: "images/flags/uk.png",
                    place: "London",
                    when: "Now Playing",
                    where: "The Prince of Wales Theatre",
                    slug: "/london/",
                    buttonCopy: "VISIT SITE"
                },
                {
                    flag: "images/flags/usa.png",
                    place: "New York",
                    when: "Now Playing",
                    where: "Eugene O'Neill Theatre",
                    slug: "/london/",
                    buttonCopy: "VISIT SITE"
                },
                {
                    flag: "images/flags/uk-eu.png",
                    place: "UK & European Tour",
                    when: "Coming Soon",
                    where: "Find Out More",
                    slug: "/uk-eu/signup/",
                    buttonCopy: "SIGN UP"
                }

            ],
        }

        this.setVideoStates = this.setVideoStates.bind(this)
        this.toggleVideoOverlay = this.toggleVideoOverlay.bind(this)
    }

    componentDidMount() {
        this.setVideoStates()
    }

    setVideoStates() {
        this.setState({
            isBackgroundVideoPlaying: true
        })
    }

    toggleVideoOverlay(e, i) {
        e.preventDefault()
        let videoOverlays = this.state.videoOverlays
        videoOverlays[i] = !this.state.videoOverlays[i]

        this.setState({
            videoOverlay: videoOverlays
        })
    }

    render() {
        return (
            <React.Fragment>
                <IndexHeader>
                    <Logo>
                        <Link to="/">
                            <img src={this.props.data.logo.childImageSharp.gatsbyImageData.images.fallback.src}
                                 alt="The Book of Mormon"/>
                        </Link>
                    </Logo>
                    {this.props.displaySocials && <Socials/>}
                </IndexHeader>
                <VideoWrap className="embed-responsive embed-responsive-1366by630 d-xl-none">
                    <ReactPlayer
                        url="https://player.vimeo.com/video/773424853"
                        playing={this.state.isBackgroundVideoPlaying}
                        volume={0}
                        muted={true}
                        controls={false}
                        loop={true}
                        className="embed-responsive-item"
                    />
                </VideoWrap>
                <VideoWrap className="embed-responsive embed-responsive-200by63 d-none d-xl-block">
                    <ReactPlayer
                        url="https://player.vimeo.com/video/773424657"
                        playing={this.state.isBackgroundVideoPlaying}
                        volume={0}
                        muted={true}
                        controls={false}
                        loop={true}
                        className="embed-responsive-item"
                    />
                </VideoWrap>
            </React.Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query={graphql`
        query {
            logo: file(relativePath: {eq: "welcome/index-logo.png"}) {
                childImageSharp {
                     gatsbyImageData(
                        width: 289
                        quality: 100,
                        placeholder: NONE
                        formats: [AUTO, WEBP, AVIF]
                     )
                }
            }
            videoPoster: file(relativePath: {eq: "welcome/video-poster.jpg"}) {
                childImageSharp {
                     gatsbyImageData(
                        width: 1920
                        quality: 100,
                        placeholder: NONE
                        formats: [AUTO, WEBP, AVIF]
                     )
                }
            }
        }`}
        render={data => (
            <CleanHeader data={data} {...props}/>
        )}
    />
)